export default __webpack_public_path__ + "static/media/NCMorrocco.0187607c.png";